export default "__VITE_ASSET__BHhxT3fE__"